import { styled } from '@mui/material/styles';
import { Datagrid } from 'shared/react-admin/Datagrids';
import { getColumnStyle } from 'utils';

export const StyledDatagrid = styled(Datagrid)({
  '& .MuiTableCell-root': {
    verticalAlign: 'middle',
  },
  '& td.MuiTableCell-paddingCheckbox': {
    paddingTop: '20px !important',
    paddingLeft: '16px',
  },
  '& th.MuiTableCell-paddingCheckbox': {
    paddingTop: '20px !important',
  },
  '& .column-createdAt': getColumnStyle(115),
});
